'use client';

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/DropdownMenu';
import ChevronDownIcon from '@/components/Icons/ChevronDown';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { useState } from 'react';

type Option = {
  value: string;
  flag?: string;
  label: string;
};

type Props = {
  title: string;
  value: string;
  options?: Option[];
  setValue: (option: Option) => void;
};

export function DropdownItem({ title, value, options, setValue }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <DropdownMenu modal={false} open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-1 text-sm p-2 uppercase focus-visible:outline-none">
          {value}
          <ChevronDownIcon
            className={cn('w-5 h-5 transition', open && 'rotate-180')}
          />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="lg:w-56 lg:min-w-96 min-w-52 bg-white text-graphite rounded-none px-4 py-2 shadow-sm">
        <DropdownMenuLabel className="uppercase font-semibold py-3">
          {title}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {options?.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.value}
            checked={option.value === value}
            onCheckedChange={() => setValue(option)}
            className="uppercase hover:outline-none focus-visible:outline-none">
            {option.flag && (
              <span className="mr-2">
                <Image
                  src={option.flag}
                  alt={option.label}
                  width={21}
                  height={15}
                  sizes="(min-width: 1280px) 80vw, (min-width: 767px) 90vw, (min-width: 480px) 100vw, 100vw"
                />
              </span>
            )}
            <span>{option.label}</span>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
